class QuickbuyGallery extends HTMLElement {
    constructor() {
       super();

       this.bindEvents = this.bindEvents.bind(this);
       this.scrollTo = this.scrollTo.bind(this);
       this.setActiveItem = this.setActiveItem.bind(this);
    }

    connectedCallback() {
        this.quickbuyGallery = this;
        this.mobileBreakpoint = 1024;
        this.isMobile = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches;

        if (this.isMobile) return;

        this.bindEvents();
    }

    bindEvents() {
        this.pagination = this.querySelector('.js-quickbuy-gallery');
        this.paginationItemsEls = this.pagination.querySelectorAll('.js-quickbuy-pagination-item');
        this.paginationImages = this.quickbuyGallery.querySelectorAll('.js-quickbuy-gallery-item');
        this.activeItem = 0;

        if (this.paginationItemsEls.length <= 1) {
            this.pagination.style.display = 'none';
            return;
        }

        this.paginationItemsEls.forEach(paginationItem => {
            paginationItem.addEventListener('click', () => {
                this.scrollTo(paginationItem);
                this.setActiveItem(paginationItem);
            })
        });

        // update pagination when media hover pagination
        this.quickbuyGallery.querySelector('.product__gallery-wrapper').addEventListener('scroll', () => {
            for (let i = 0; i < this.paginationImages.length; i++) {
                var fixed_position = this.paginationItemsEls[i].getBoundingClientRect().top;
                var fixed_height = this.paginationItemsEls[i].offsetHeight;

                var toCross_position = this.paginationImages[i].getBoundingClientRect().top;
                var toCross_height = this.paginationImages[i].offsetHeight;

                // compare i media element to i pagination item position - if they match update active item
                const mediaHoverPagination = fixed_position + fixed_height < toCross_position || fixed_position > toCross_position + toCross_height;
                if (!mediaHoverPagination) {
                    this.setActiveItem(this.paginationItemsEls[i])
                }
            }
        });
    }

    scrollTo(paginationItem) {
        const mediaEl = this.querySelector(`#${paginationItem.dataset.target}`);
        mediaEl.scrollIntoView({ behavior: 'smooth' });
    }

    setActiveItem(paginationItem) {
        if (this.activeItem === paginationItem.dataset.item) { return; }

        this.activeItem = paginationItem.dataset.item;
        this.paginationItemsEls.forEach(paginationItem => {
            paginationItem.classList.remove('slider-pagination-bullet--active');
        });
        paginationItem.classList.add('slider-pagination-bullet--active');
    }
}

// prevent from initializing twice
if (customElements.get('quickbuy-gallery') === undefined)  {
   customElements.define('quickbuy-gallery', QuickbuyGallery);
}
